import { GenderChicken } from "./../pages/sales-order/components/SalesOrderModalV2";

export enum EnumUomPriceList {
	"KG" = "KG",
}

export enum EnumCurrencyPriceList {
	"VND" = "VND",
}

export enum EnumStatusPriceList {
	valid = "valid", // đang áp dụng
	invalid = "invalid", // hết hiệu lực
	notYetApplied = "notYetApplied", // chưa áp dụng
}

export interface GetPriceListByCustomerCodeAndProDuctCodeAndFarmIdQuery {
	farmId: number;
	customerCode: string;
	productCode: string;
	status: keyof typeof EnumStatusPriceList;
	chickenType: number;
	validFrom: string;
	validTo: string;
}

export interface GetPriceListByIdsQuery extends Pick<GetPriceListByCustomerCodeAndProDuctCodeAndFarmIdQuery, "status"> {
	ids: number[];
}

export interface PriceListResponse {
	id: number;
	priceListCode: string;

	customerCode: string;
	customerName: string;

	farmCode: string;
	farmName: string;

	farmId: number;

	productCode: string;
	productName: string;

	chickenType: number;
	gender: keyof typeof GenderChicken;

	priceAmount: number;
	currency: keyof typeof EnumCurrencyPriceList;

	uom: string;

	applyAllHouse: boolean;

	status: keyof typeof EnumStatusPriceList;
	isDeleted: boolean;
	isInactive: boolean;

	validFrom: string;
	validTo: string;

	createdAt: string;
	createdBy: string;

	updatedAt: string;
	updatedBy: string | null;
}

export interface SalesOrderReportV2Response {
	id: number;
	salesOrderDetailId: number;
	farmCode: string;
	farmName: string;
	customerId: string;
	customerName: string;
	orderDate: string;
	shipDate: string;
	itemCode: string;
	itemName: string;
	chickenType: number;
	startTimeScale: string;
	endTimeScale: string;
	status: string;
	invoiceStatus: string;
	orderQuantity: number;
	totalQuantity: number;
	totalWeightNet: number;
	gender: string;
	priceListCode: string;
	currentPrice: number;
	totalAmount: number;
	referSolomon?: string;
	billingNo?: string;
	invoiceDate?: string;
	invoiceNo?: string;
}
